import React, { useState } from "react";
import Modal from "react-modal";
import Slide from "./Slide";

const styles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.6)",
    zIndex: 50,
  },
  content: {
    background: "transparent",
    border: "none",
    overflowX: "hidden",
    inset: 0,
    top: 0,
    bottom: 0,
    padding: 0,
    display: "flex",
  },
};

export default ({ show, hide, slide = 0, items = [] }) => {
  const [currentSlide, setSlide] = useState(slide);

  const previous = () => {
    if (currentSlide > 0) setSlide(currentSlide - 1);
  };

  const next = () => {
    if (currentSlide < items.length - 1) setSlide(currentSlide + 1);
  };

  // Close slider when overlay is clicked
  const onSlideClick = event => {
    if (event.target.className === "slide") hide();
  };

  if (!show) return null;

  return (
    <Modal isOpen={show} style={styles} shouldCloseOnOverlayClick>
      {items.length > 1 && <div className="slideshow_arrow_backdrop"></div>}
      <div
        className="slideshow"
        onClick={onSlideClick}
        style={{
          width: `calc(100vw * ${items.length})`,
          transform: `translate(calc(-${currentSlide} * 100vw))  `,
        }}
      >
        {items &&
          items.map((item, index) => (
            <Slide
              key={index}
              {...item}
              hide={hide}
              previousWork={previous}
              nextWork={next}
              isFirst={index === 0}
              isLast={index === items.length - 1}
              isFocused={currentSlide === index}
            />
          ))}
      </div>
    </Modal>
  );
};
